import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { FutureOrderMode } from "src/app/shared/models/enums/future-order-mode.enum";
import { OOOrderType } from "src/app/shared/models/oo-order-type";

@Component({
	selector: "app-order-type-time-change",
	templateUrl: "./order-type-time-change.component.html",
	styleUrls: ["../online-order.component.scss"],
})
export class OrderTypeTimeChangeComponent implements OnInit {
	@Input() isMobile: boolean;
	@Input() orderTypes: OOOrderType[];
	@Input() venueKey: number;

	@Output() confirmationEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

	@Input() orderDueDateTime: string;
	@Output() orderDueDateTimeChange = new EventEmitter<string>();

	@Input() orderTypeSelected: OOOrderType;
	@Output() orderTypeSelectedChange = new EventEmitter<OOOrderType>();

	@Input() futureOrderDate: Date;
	@Output() futureOrderDateChange = new EventEmitter<Date>();
	@Input() futureOrderTime: string;
	@Output() futureOrderTimeChange = new EventEmitter<string>();

	@Input() futureOrderMode: number;
	@Output() futureOrderModeChange = new EventEmitter<number>();

	futureOrdersAllowed: boolean = false;
	futureOrderTimeOptions: any[];

	maxFutureSelectDate: Date = moment().toDate();
	moment: any = moment;

	timeOptions = [
		{
			value: 1,
			label: "Order for ASAP",
			inactive: false,
		},
	];
	timeOptionSelected: number = 1;
	today: Date = new Date();

	visible: boolean = true;

	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		if (this.orderTypes.some((i) => i.futureOrders && i.active) && this.futureOrderMode) {
			this.timeOptions.push({
				value: 2,
				label: `Order for Later ${this.futureOrderMode === FutureOrderMode.TODAY ? "Today" : ""}`,
				inactive: false,
			});
			this.futureOrdersAllowed = true;
		}

		if (this.futureOrderTime && this.futureOrderDate) {
			this.timeOptionSelected = 2;
			this.selectFutureOrderDate(this.futureOrderDate);
		}

		if (this.futureOrderMode === FutureOrderMode.FUTURE) {
			this.maxFutureSelectDate = moment().add(this.venueService.ooVenue.futureOrderThreshold, "days").toDate();
		} else {
			this.maxFutureSelectDate = moment().toDate();
		}

		for (let i = 0; i < this.orderTypes.length; i++) {
			if (this.orderTypes[i].atTable || this.orderTypes[i].useLinkKeyTable) {
				this.orderTypes.splice(i, 1);
			} else {
				this.orderTypes[i].inactive = this.orderTypes[i].active ? false : true;
			}
		}
		if (this.orderTypeSelected.inactive) {
			const selectedOtInList = this.orderTypes.find((i) => i.key === this.orderTypeSelected.key);
			selectedOtInList.inactive = true;
		}

		this.evaluateOrderTypeSelection();
	}

	selectFutureOrderDate(date) {
		const m = moment(date);
		this.futureOrderTimeOptions = this.venueService.futureOrderTimeSlots[m.day()];
		if (m.isSame(moment(), "days")) {
			this.futureOrderTimeOptions = this.futureOrderTimeOptions.filter((o) => {
				const mIdx = moment(date).hour(o.value.split(":")[0]).minute(o.value.split(":")[1]).second(0);
				if (mIdx.isSameOrAfter(moment(), "minutes")) {
					if (mIdx.isBefore(moment().add(this.venueService.ooVenue.orderLeadTime, "minutes"))) {
						return false;
					}
					return true;
				}
			});
		}
		if (this.futureOrderTimeOptions.length === 0) {
			this.futureOrderTimeOptions = [
				{
					label: "No Times Available",
					disabled: true,
				},
			];
		}
		this.futureOrderTime = this.futureOrderTime ? this.futureOrderTime : null;
	}

	async evaluateOrderTypeSelection() {
		const timeOpt = [...this.timeOptions];
		if (!this.orderTypeSelected.futureOrders) {
			const future = timeOpt.find((i) => i.value === 2);
			if (future) {
				future.inactive = true;
			}
		} else {
			const future = timeOpt.find((i) => i.value === 2);
			if (future) {
				future.inactive = false;
			}
		}
		this.timeOptions = [];
		this.timeOptions = timeOpt;

		if (this.timeOptionSelected === 1) {
			this.userAsapOrderTimeSelect();
		}
	}

	evaluateTimeSelection(event) {
		const ots = [...this.orderTypes];
		for (let ot of ots) {
			if (event.value === 2 && !ot.futureOrders) {
				ot.inactive = true;
			} else {
				ot.inactive = false;
			}
		}
		this.orderTypes = [];
		this.orderTypes = ots;
	}

	userConfirmation() {
		this.emitValues();
		this.confirmationEmitter.emit(false);
	}

	userOrderTypeSelect(event) {
		this.evaluateOrderTypeSelection();
		this.orderTypeSelectedChange.emit(this.orderTypeSelected);
	}

	userTimeSelect(event) {
		this.evaluateTimeSelection(event);
		if (this.timeOptionSelected === 2) {
			this.selectFutureOrderDate(new Date());
			this.userFutureOrderTimeSelect();
		} else {
			this.userAsapOrderTimeSelect();
		}
		this.emitValues();
	}

	userAsapOrderTimeSelect() {
		this.orderDueDateTime = moment().add(this.venueService.ooVenue.orderLeadTime, "minutes").add(this.orderTypeSelected.orderLeadTime, "minutes").format();
	}

	userFutureOrderTimeSelect() {
		this.orderDueDateTime = moment(`${moment(this.futureOrderDate).format("YYYY-MM-DD")} ${this.futureOrderTime}`, "YYYY-MM-DD HH:mm").format();
		this.emitValues();
	}

	emitValues() {
		this.futureOrderTimeChange.emit(this.futureOrderTime);
		this.futureOrderDateChange.emit(this.futureOrderDate);
		this.orderDueDateTimeChange.emit(this.orderDueDateTime);
		this.orderTypeSelectedChange.emit(this.orderTypeSelected);
	}
}
